import React from "react";
import { Reveal } from "../shared/Reveal";

export default function Philosophy() {
  return (
    <section className="philosophy">
      <div className="wrap">
        <Reveal className="eyebrow" tag="div">DIAGNOSE FIRST · INVEST SECOND</Reveal>
        <div className="rule" style={{ marginTop: 26 }} />
        <Reveal tag="blockquote" className="pq">"A good doctor doesn't prescribe treatment before making a diagnosis."</Reveal>
        <Reveal className="pbody" tag="div">
          <p>For years, our industry has often prescribed solutions before fully understanding the building.</p>
          <p>Today, technology allows us to <b>diagnose first and invest second</b>.</p>
          <p>This means we can now understand how every building performs before making a single recommendation.</p>
        </Reveal>
      </div>
    </section>
  );
}
